<!-- Translated: yes -->
<template>
  <div class="component">
    <Back :clicked="goBack" />
    <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="false" @pickedlanguage="reMount" />

    <div v-if="!SITE_CONFIG.modules_open.skiletting.open" class="rental-closed">
      <p>{{ SITE_CONFIG.modules_open.skiletting.closed_message }}</p>
    </div>

    <div v-if="SITE_CONFIG.modules_open.skiletting.open">
    <Timeline :steps="timelineSteps"></Timeline>
    <OnSiteFooter v-if="$store.state.isOnSite" />


    <transition name="animate-filter">
      <h1 v-if="people[currentIndex]">{{ $t('skirental.enter-details', {name: ''}) }} {{people[currentIndex].name}}</h1>
    </transition>

    <div
      :class="{person: true, opened: (currentIndex === index), completed: (person.guideFullyCompleted && currentIndex !== index)}"
      v-for="(person, index) in people"
      v-if="person.guideCompleted">


      <div class="blue-bar" @click="setActive(currentIndex !== index ? index : -1)">
        <div class="inner">
          <span class="name">{{person.name}}:</span>
          <span class="package max-tablet">
            <b v-if="person.type === 'package'">{{ $t('skirental.package', {package: ''}) }} {{categories[person.subCategory] || categories[person.category]}}:</b>
            <b v-if="person.type === 'single'">{{categories[person.subCategory] || categories[person.category]}}:</b>
            <b v-if="person.type !== 'single' && person.type !== 'package'">
              <b v-if="person.onlySkipass">{{ $t('general.skipass') }}:</b>
            </b>
            {{ages[person.age]}}
          </span>
          <span class="level max-tablet">
            <span v-if="person.searchPackage === 'beginner'"><b>{{ $t('general.level') }}:</b> {{ $t('general.levels.beginner') }}</span>
            <span v-if="person.searchPackage === 'intermediate'"><b>{{ $t('general.level') }}:</b> {{ $t('general.levels.average') }}</span>
            <span v-if="person.searchPackage === 'advanced'"><b>{{ $t('general.level') }}:</b> {{ $t('general.level.advanced') }}</span>
          </span>
          <span class="date max-tablet" v-if="!hasClosedDaysInRange(person)">
            <span><b>{{ $t('general.date') }}:</b> {{ dateRange(person) | dateRange('long') }}</span>
          </span>
          <span class="date max-tablet" v-if="hasClosedDaysInRange(person)">
            <span><b>{{ $t('general.date') }}:</b> {{ person.days }} {{ $t('general.days') }}</span>
          </span>
          <span v-if="currentIndex === index" class="change max-tablet">
            <!--<button class="small white tight" @click.stop="changeDate()"><icon name="edit-blue" :scale="1.2" /> Ändra datum</button>-->
            <button class="small white tight" @click.stop="remove(index)"><icon name="trash" :scale="1.5" /></button>
          </span>
        </div>
        <span v-if="currentIndex !== index" class="show-or-close">
          <div class="text">
            {{ $t('general.show') }}
          </div>
          <div class="arrow">
            <icon v-if="person.guideFullyCompleted" name="chevron-down-green" :scale="1.9" />
            <icon v-if="!person.guideFullyCompleted" name="chevron-down-blue" :scale="1.9" />
          </div>
        </span>
        <span v-if="currentIndex === index" class="show-or-close">
          <div class="text">
            {{ $t('general.close') }}
          </div>
          <div class="arrow">
            <icon v-if="person.guideFullyCompleted" name="chevron-up-white" :scale="1.9" />
              <icon v-if="!person.guideFullyCompleted" name="chevron-up-white" :scale="1.9" />
          </div>
        </span>
      </div>

      <transition name="animate-filter">

      <div v-show="(currentIndex === index)">

      <div class="inner-width">

        <div class="flex sizes-list">
          <div class="control" v-if="required(index, 'lengthCm')">
            <div class="label">{{ $t('skirental.measurements.length-your') }} ({{ $t('skirental.measurements.centimeter-short') }})<span class="required">*</span></div>
            <Dropdown
              :combo="true"
              :options="lengthOptionsCalculated(person)"
              :valuebinder.sync="person.lengthCm"
              :label="$t('skirental.example-centimeter')"
               :validated="person.lengthCm && !showError(index, 'lengthCm', true)"
               :error="showError(index, 'lengthCm', true)"
               :show-label-subtitle="false"
               @touch="touch(index, 'lengthCm')"
              />
          </div>

          <div class="control" v-if="required(index, 'weight')">
            <div class="label">{{ $t('skirental.measurements.weight') }} ({{ $t('skirental.measurements.kilogram-short') }})<span class="required">*</span></div>
            <Dropdown
              :combo="true"
              :options="lengthOptions[person.age].weightOptions"
              :valuebinder.sync="person.weight"
              :label="$t('skirental.example-kilogram')"
               :validated="person.weight && !showError(index, 'weight', true)"
               :error="showError(index, 'weight', true)"
               :show-label-subtitle="false"
               @touch="touch(index, 'weight')"
              />
          </div>

          <div class="control" v-if="required(index, 'shoeSize')">
            <div class="label">{{ $t('skirental.measurements.shoesize') }}<span class="required">*</span> <button @click="openModal(['SkiRentalFoot', {index: index}])" class="small white border tight"><icon name="info-blue" :scale="1" /> {{ $t('general.info-short') }}</button></div>
            <Dropdown
              :combo="false"
              :options="shoesizeOptionsCalculated(person)"
              :valuebinder.sync="person.shoeSize"
              :label="$t('general.pick')"
               :validated="person.shoeSize && !showError(index, 'shoeSize', true)"
               :error="showError(index, 'shoeSize', true)"
               :show-label-subtitle="true"
               @touch="touch(index, 'shoeSize')"
              />
          </div>

          <div class="control" v-if="required(index, 'jacketsize')">
            <div class="label">Jackstorlek (unisex)<span class="required">*</span></div>
            <Dropdown
              :combo="false"
              :options="productSizes(person, '_jacketsizes')"
              :valuebinder.sync="person.jacketsize"
              :label="'Jackstorlek'"
               :validated="person.jacketsize && !showError(index, 'jacketsize', true)"
               :error="showError(index, 'jacketsize', true)"
               :show-label-subtitle="false"
               @touch="touch(index, 'jacketsize')"
              />
          </div>

          <div class="control" v-if="required(index, 'pantsize')">
            <div class="label">Byxstorlek (unisex)<span class="required">*</span></div>
            <Dropdown
              :combo="false"
              :options="productSizes(person, '_pantsizes')"
              :valuebinder.sync="person.pantsize"
              :label="'Byxstorlek'"
               :validated="person.pantsize && !showError(index, 'pantsize', true)"
               :error="showError(index, 'pantsize', true)"
               :show-label-subtitle="false"
               @touch="touch(index, 'pantsize')"
              />
          </div>

          <div class="control" v-if="required(index, 'clothsize')">
            <div class="label">Klädstorlek<span class="required">*</span></div>
            <Dropdown
              :combo="false"
              :options="lengthOptions[person.age].clothSizeOptions"
              :valuebinder.sync="person.clothsize"
              :label="'Klädstorlek'"
               :validated="person.clothsize && !showError(index, 'clothsize', true)"
               :error="showError(index, 'clothsize', true)"
               :show-label-subtitle="false"
               @touch="touch(index, 'clothsize')"
              />
          </div>

          <div class="control">
            <div v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'kungsberget' || SITE_CONFIG.site === 'storstenshojden'">
              <div class="label">{{ $t('skirental.wishes.title') }}</div>
              <FilterListItem v-if="wish && key !== 'hasWishes'" :label="wishesLabels[key]" :value="key" @click="removeWish(index, key)" v-for="(wish, key) in person.wishes" :key="key" />
              <button v-if="!person.wishes.hasWishes" class="border-bottom underlined small-text wishes-bt" @click="openWishes">{{ $t('skirental.wishes.add') }}</button>
              <button v-if="person.wishes.hasWishes" class="border-bottom underlined small-text wishes-bt" @click="openWishes">{{ $t('skirental.wishes.change') }}</button>
            </div>
          </div>
        </div>

        <span v-show="showError(index, 'lengthCm', true)" class="error-message">{{ showError(index, 'lengthCm') }}</span>
        <span v-show="showError(index, 'weight', true) && !showError(index, 'lengthCm', true)" class="error-message">{{ showError(index, 'weight') }}</span>
        <span v-show="showError(index, 'shoeSize', true) && !showError(index, 'lengthCm', true) && !showError(index, 'weight', true)" class="error-message">{{ showError(index, 'shoeSize') }}</span>

      </div>

      <div class="--inner-width">

        <div class="addons inner-width">
          <h4 v-if="!person.onlySkipass && person.possibleAddons && person.possibleAddons.length">{{ $t('skirental.rent-addon') }}</h4>
          <div class="addon-list" v-if="!person.onlySkipass">
            <div v-for="product in person.possibleAddons" :class="{
              active: productIsAdded(index, product)
              }"
              v-if="showProduct(index, product)"
              >
              <div :class="{image: true, 'default-image': true, 'has-description': !!product.description}" @click.stop="infoPopup(product)" :style="product.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + product.image + ')' : 'background-size:cover;'">
                <icon name="info-blue" :scale="0.9" />
              </div>
              <div class="content">
                <h4>{{product.name}}</h4>
                <p>
                  {{(person.priceType === 'night' && SITE_CONFIG.site !== 'vallasen') ? '' : person.days}} {{
                    (person.priceType === 'night' ?
                      (SITE_CONFIG.site === 'vallasen' ? $t('general.night') : $t('skirental.day-options.hours', { hours: SITE_CONFIG.rental.night_hours })) :
                      (person.days > 1 ? $t('general.days') : $t('general.day'))
                    )
                  }}
                </p>
                <b>{{product['price_' + person.days + (person.priceType === 'night' ? '_night' : '')] | currency}}</b>
                <button @click="addAddon(index, product)" :class="{
                  small: true,
                  green: productIsAdded(index, product),
                  'float-right': true
                  }">
                  {{productIsAdded(index, product) ? $t('general.picked') : $t('general.pick')}}
                </button>
              </div>
            </div>
          </div>

          <h4 v-if="!person.onlySkipass && person.possibleBuy && person.possibleBuy.length">{{ $t('skirental.buy-addon') }}</h4>
          <div class="addon-list" v-if="!person.onlySkipass">
            <div v-for="product in person.possibleBuy" :class="{
              active: productIsAdded(index, product)
              }"
              v-if="showProduct(index, product)"
              >
              <div :class="{image: true, 'default-image': true, 'has-description': !!product.description}" @click.stop="infoPopup(product)" :style="product.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + product.image + ')' : 'background-size:cover;'">
                <icon name="info-blue" :scale="0.9" />
              </div>
              <div class="content">
                <h4>{{product.name}}</h4>
                <p v-if="(product.code || '').match(/liftkort|skipass/ig)">
                  {{(person.priceType === 'night' && SITE_CONFIG.site !== 'vallasen') ? '' : person.days}} {{
                    (person.priceType === 'night' ?
                      (SITE_CONFIG.site === 'vallasen' ? $t('general.night') : $t('skirental.day-options.hours', { hours: SITE_CONFIG.rental.night_hours })) :
                      (person.days > 1 ? $t('general.days') : $t('general.day'))
                    )
                  }}
                </p>
                <b>{{product['price_' + person.days + (person.priceType === 'night' ? '_night' : '')] | currency}}</b>
                <button @click="addAddon(index, product)" :class="{
                  small: true,
                  green: productIsAdded(index, product),
                  'float-right': true
                  }">
                  {{productIsAdded(index, product) ? $t('general.picked') : $t('general.pick')}}
                </button>
              </div>
            </div>
          </div>

          <div class="products">
            <div class="heading-products">{{ $t('general.summary') }}</div>
            <table>
              <tr v-for="(product, iindex) in person.products">
                <td>
                  {{product.name}}
                </td>
                <td class="price" v-if="product">
                  <b>{{product.price | currency}}</b>
                </td>
              </tr>
              <tr v-for="(product, iindex) in person.addons">
                <td>
                  {{product.name}}
                </td>
                <td class="price" v-if="product">
                  <b>{{product.price | currency}}</b>
                </td>
              </tr>
              <tr class="total">
                <td>
                  {{ $t('general.price') }} {{person.name}}
                </td>
                <td class="price">
                  <b>{{
                    (
                    person.products.reduce(function(a, product) {
                      return a + product.price
                    }, 0)
                    +
                    person.addons.reduce(function(a, product) {
                      return a + product.price
                    }, 0)
                    ) | currency
                  }}</b>
                </td>
              </tr>
            </table>

          </div>

          <div style="clear:both;"></div>

        </div>

      </div>

      </div>

      </transition>

    </div>

    <div class="sum-bar">
      <div class="inner" style="text-align:right;">
        {{ $t('general.total-neutrum') }}:
        <b>
          {{
            sum | currency
          }}
        </b>
      </div>
    </div>


    <div class="center space-3 button-confirm">
      <button v-if="nextIndex" @click="next()" :class="{disabled: !validate()}">{{ $t('general.go-on-to-next-skier') }}</button>
      <button v-if="!nextIndex" :class="{small: true, white: true, border: true, big: true, disabled: !validate()}" @click="addPerson()">{{ $t('general.add-skier') }}</button>
      <span v-if="!nextIndex" style="margin-left:15px;margin-right:15px;"> ... {{ $t('general.or') }} ... </span>
      <button v-if="!nextIndex" @click="doRental()" :class="{disabled: !validate()}">{{ $t('general.complete-booking') }}</button>
      <!--<span v-if="nextIndex" style="margin-left:15px;margin-right:15px;"> ... eller ... </span>
      <button v-if="nextIndex" class="small white border big" @click="doRental()" :disabled="!validate()">{{$store.state.isOnSite ? 'Betala' : 'Lägg i varukorg'}}</button>-->
    </div>

  </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';
import Timeline from '@/components/components/Timeline';
import OnSiteFooter from '@/components/components/OnSiteFooter';
import Dropdown from '@/components/components/Dropdown';
import Back from '@/components/components/Back';
import FilterListItem from '@/components/parts/Accomodation/List/Filter/FilterListItem';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import rentalTimelineSteps from '@/mixins/rentalTimelineSteps';

import {
  hasClosedDaysInRange,
} from '@/lib';

import moment from 'moment';
import { createValidMeasurements } from '@/lib/measurements';

export default {
  data() {
    return {
      people: [],
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen',
      },
      lengthOptions: {},
      categories: {},
      validStartDates: [],
      allAddons: [],
      touched: {},
      helmet_id: null,
    };
  },
  mixins: [rentalTimelineSteps],
  components: {
    Timeline,
    FilterListItem,
    Dropdown,
    OnSiteFooter,
    Back,
    LanguageSwitcher,
  },
  mounted() {
    this.ages = {
      children: this.$i18n.t('general.ages.child'),
      youths: this.$i18n.t('general.ages.youth'),
      adults: this.$i18n.t('general.ages.adult'),
    };

    this.reMount();
  },
  computed: {
    sum() {
      /* eslint-disable */
      return this.people.reduce((a, person) => {
        return a + person.products.reduce((b, product) => {
          return b + product.price;
        }, 0) + person.addons.reduce((b, product) => {
          return b + product.price;
        }, 0);
      }, 0);
    },
    wishesLabels() {
      return {
        wideCalf: this.$i18n.t('skirental.wishes.options.wideCalf'),
        wideFoot: this.$i18n.t('skirental.wishes.options.wideFoot'),
        softShoes: this.$i18n.t('skirental.wishes.options.softShoes'),
        hardShoes: this.$i18n.t('skirental.wishes.options.hardShoes'),
        shortTurn: this.$i18n.t('skirental.wishes.options.shortTurn'),
        longTurn: this.$i18n.t('skirental.wishes.options.longTurn'),
        startSki: this.$i18n.t('skirental.wishes.options.skis'),
        startSnowboard: this.$i18n.t('skirental.wishes.options.snowboard'),
        preferedFootLeft: this.$i18n.t('skirental.wishes.options.preferedFootLeft'),
        preferedFootRight: this.$i18n.t('skirental.wishes.options.preferedFootRight'),
        freeText: this.$i18n.t('skirental.wishes.own'),
      };
    },
    guideCompleted() {
      return this.people.filter(person => person.guideCompleted);
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'confirmRental',
      'completeGuides',
      'addRentalAddon',
      'removeRentalAddon',
      'addRentalPeople',
      'closeModal',
      'closeAllModals',
      'clearCart',
      'setGuideCompleted',
    ]),
    required(index, type) {
      let person = this.people[index];

      let weight = false;
      let length = false;
      let shoesize = false;
      let pantsize = false;
      let jacketsize = false;
      let clothsize = false;

      person.products.forEach((product) => {
        weight = product.required.weight ? true : weight;
        length = product.required.lengthCm ? true : length;
        shoesize = product.required.shoesize ? true : shoesize;
        pantsize = product.required.pantsize ? true : pantsize;
        jacketsize = product.required.jacketsize ? true : jacketsize;
        clothsize = product.required.clothsize ? true : clothsize;
      });

      person.addons.forEach((addon) => {
        weight = addon.required.weight ? true : weight;
        length = addon.required.lengthCm ? true : length;
        shoesize = addon.required.shoesize ? true : shoesize;
        pantsize = addon.required.pantsize ? true : pantsize;
        jacketsize = addon.required.jacketsize ? true : jacketsize;
        clothsize = addon.required.clothsize ? true : clothsize;
      });

      if (type === 'weight') {
        return weight;
      }
      if (type === 'lengthCm') {
        return length;
      }
      if (type === 'shoeSize') {
        return shoesize;
      }
      if (type === 'pantsize') {
        return pantsize;
      }
      if (type === 'jacketsize') {
        return jacketsize;
      }
      if (type === 'clothsize') {
        return clothsize;
      }

      return false;
    },
    productSizes(person, type) {
      const sizes = [];

      person.products.forEach((product) => {
        console.log('SkiRentalUserOverview.vue productSizes', product, type);
        product[type].forEach((size) => {
          sizes.push(size);
        });
      });

      person.addons.forEach((addon) => {
        addon[type].forEach((size) => {
          sizes.push(size);
        });
      });

      const newSizes = sizes.filter((value, index, self) => { 
        return self.indexOf(value) === index;
      });

      return newSizes.map((size) => {
        return {
          value: size,
          title: size,
        };
      })
    },
    async reMount() {
      if (this.$route.query['add-more']) {
        this.addPerson(true);
      }

      /* if (this.$route.query.action && this.$route.query.action === 'add') {
        if (this.$route.query.category === 'skipass') {
          this.setGuideCompleted({index: this.$route.query.person});
        }
      } */

      let shoeMinChildren = 25;

      if (this.SITE_CONFIG.site === 'branas') {
        shoeMinChildren = 24;
      }

      this.lengthOptions.children = this.createValidMeasurements({
        cmMin: 85,
        cmMax: 150,
        kgMin: 15,
        kgMax: 45,
        shoeMin: shoeMinChildren,
        shoeMax: 39,
        clothGroup: 'child_youth',
      });
      this.lengthOptions.youths = this.createValidMeasurements({
        cmMin: 120,
        cmMax: 185,
        kgMin: 25,
        kgMax: 100,
        shoeMin: 32,
        shoeMax: 49,
        clothGroup: 'child_youth',
      });
      this.lengthOptions.adults = this.createValidMeasurements({
        cmMin: 120,
        cmMax: 195,
        kgMin: 40,
        kgMax: 130,
        shoeMin: 32,
        shoeMax: 49,
        clothGroup: 'adult',
      });
      this.lengthOptions.seniors = this.createValidMeasurements({
        cmMin: 120,
        cmMax: 195,
        kgMin: 40,
        kgMax: 130,
        shoeMin: 32,
        shoeMax: 49,
        clothGroup: 'adult',
      });

      this.validStartDates = [];
      const loopStart = moment(this.SITE_CONFIG.season.winter.start).subtract(1, 'day').toDate();
      let current = loopStart;
      const end = moment(this.SITE_CONFIG.season.winter.end).toDate();
      let next = null;

      while (current < end) {
        next = moment(current).add(1, 'days');
        if (this.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1) {
          this.validStartDates.push(next.format('YYYY-MM-DD'));
        }
        current = next.toDate();
      }

      this.people = this.$store.state.cart.rentals; // Todo, not correct way to alter the store

      const completed = this.people.filter(person => person.guideCompleted);
      const fullyCompleted = this.people.filter(person => person.guideFullyCompleted);
      this.nextIndex = completed.length;
      this.currentIndex = fullyCompleted.length;

      if (completed.length === this.people.length) {
        this.nextIndex = 0;
      }

      if (!completed.length) {
        this.$router.replace({ name: 'ski rental' });
      }

      const { meta } = await API.get(`/skiletting/search?age=&type=${this.selectedType}&level=${this.selectedLevel}&category=${this.selectedCategory}&addon=1`);
      this.categories = meta.categories_all;
      this.helmet_id = meta.helmet_id;

      /* eslint-disable */
      let index = 0;
      const $this = this;

      for (index in this.people) {
        let person = this.people[index];
        if (!person.onlySkipass) {
          const category = person.subCategory || person.category;
          let date = '';
          if (person.startDate) {
            date = moment(person.startDate).format('YYYY-MM-DD');
          }
          const { data, buy } = await API.get(`/skiletting/search?age=${person.age}&addon=1&days=${person.days}&date=${date}&addon-filter-category=${category}`);
          this.people[index].possibleAddons = data;
          this.people[index].possibleBuy = [];
          buy.forEach((product) => {
            const newProduct = Object.assign({}, product);
            newProduct.buy = true;
            this.people[index].possibleBuy.push(newProduct);
          });
        }
      }

      /* if (this.$route.query.action && this.$route.query.action === 'add') {
        if (this.$route.query.category === 'skipass') {
          const addons = [];
          this.people[index].possibleAddons.forEach((product, index) => {
            if (product && product.categories) {
              const match = product.categories.filter((category) => {
                return category.slug === 'skipass';
              });
              if (match.length) {
                addons.push(product);
              }
            }
          });

          this.people[index].possibleBuy.forEach((product) => {
            if (product && product.categories) {
              const match = product.categories.filter((category) => {
                return category.slug === 'skipass';
              });
              if (match.length) {
                addons.push(product);
              }
            }
          });

          if (addons && addons.length) {
            addons.forEach((product) => {
              this.addAddon(parseInt(this.$route.query.person, 10), product, true);
            });
          }
        }
      } */
    },
    lengthOptionsCalculated(person) {
      if (person.category === 'snowboard') {
        return this.lengthOptions[person.age].lengthOptions.filter(v => v.value >= 100);
      }
      if (this.SITE_CONFIG.site === 'kungsberget') {
        if (person.subCategory === 'cross_country') {
          return this.lengthOptions[person.age].lengthOptions.filter(v => v.value >= 135);
        }
      }

      let code = person.products.map(p => p.code).filter((value, index, self) => self.indexOf(value) === index).join('|');

      if (code === 'WE RYGGSKYDD') {
        return this.lengthOptions[person.age].lengthOptions.filter(v => v.value >= 110);
      }
      if (code === 'WE SKIDKLÄDER' || code === 'WE HYRKLÄDER SET' || code === 'WE HYRKLÄDER JACKA'
        || code === 'WE HYRKLÄDER BYXA' || code === 'WE SKIDJACKA' || code === 'WE SKIDBYXA') {
        return this.lengthOptions[person.age].lengthOptions.filter(v => v.value >= 125);
      }
      return this.lengthOptions[person.age].lengthOptions;
    },
    shoesizeOptionsCalculated(person) {
      if (this.SITE_CONFIG.site === 'vallasen') {
        if (person.category === 'snowboard') {
          return this.lengthOptions[person.age].shoeSizeOptions.filter(v => v.value >= 33);
        }
      }
      if (this.SITE_CONFIG.site === 'kungsberget') {
        if (person.subCategory === 'cross_country') {
          return this.lengthOptions[person.age].shoeSizeOptions.filter(v => (v.value >= 33 && v.value <= 47));
        }
      }
      return this.lengthOptions[person.age].shoeSizeOptions;
    },
    createValidMeasurements(config) {
      return createValidMeasurements(config, this.$i18n.t.bind(this.$i18n));
    },
    touch(index, key) {
      if (!this.touched[index]) {
        this.touched[index] = {};
        this.$set(this.touched, index, {});
      }
      this.$set(this.touched[index], key, true);
    },
    showError(index, key, considerTouched) {
      if (!this.required(index, key)) {
        return '';
      }

      if (considerTouched) {
        if (!this.touched[index] || !this.touched[index][key]) {
          return '';
        }
      }

      const person = this.people[index];
      const value = person[key];
      let min = 0;
      let max = 0;

      const cols = {
        weight: this.$i18n.t('skirental.measurements.weight'),
        lengthCm: this.$i18n.t('skirental.measurements.length'),
        shoeSize: this.$i18n.t('skirental.measurements.shoesize'),
        pantsize: 'Byxstorlek',
        jacketsize: 'Jackstorlek',
        clothsize: 'Klädstorlek',
      };

      if (key === 'weight') {
        min = this.lengthOptions[person.age].weightOptions[0].value;
        max = this.lengthOptions[person.age].weightOptions[this.lengthOptions[person.age].weightOptions.length - 1].value;
      }
      if (key === 'lengthCm') {
        min = this.lengthOptionsCalculated(person);
        max = this.lengthOptionsCalculated(person)[this.lengthOptionsCalculated(person).length - 1];
        min = min[0].value;
        max = max.value;
      }
      if (key === 'shoeSize') {
        min = this.lengthOptions[person.age].shoeSizeOptions[0].value;
        max = this.lengthOptions[person.age].shoeSizeOptions[this.lengthOptions[person.age].shoeSizeOptions.length - 1].value;
      }

      const title = cols[key];

      if (!value) {
        return this.$i18n.t('skirental.rules.mandatory', { field: title });
      }

      if (key === 'pantsize' || key === 'jacketsize') {
        return '';
      }

      if (value < min) {
        return this.$i18n.t('skirental.rules.min', { field: title, min });
      }
      if (value > max) {
        return this.$i18n.t('skirental.rules.max', { field: title, max });
      }

      return '';
    },
    addPerson(replace) {
      this.touchAll();
      if (!this.validate()) {
        return false;
      }

      const peopleToClone = this.$store.state.cart.rentals.filter(rental => rental.guideCompleted);

      this.addRentalPeople({
        peopleCount: 1,
        pickedStartDate: peopleToClone[0].startDate,
        numberOfDays: peopleToClone[0].days,
        delivery: peopleToClone[0].delivery,
        deliveryTo: Object.assign({}, peopleToClone[0].deliveryTo),
        append: true,
        priceType: peopleToClone[0].priceType,
      });
      this.completeGuides();
      let next = this.$store.state.cart.rentals.length - 1;

      if (replace) {
        this.$router.replace({ path: `/skidhyra/${next}` });
      } else {
        this.$router.push({ path: `/skidhyra/${next}` });
      }
    },
    productIsAdded(personIndex, product) {
      const addons = this.people[personIndex].addons;
      let isMatch = false;
      addons.forEach((addon) => {
        if (addon.pool_lid === product.pool_lid) {
          isMatch = true;
        }
      });
      return isMatch;
    },
    showProduct(personIndex, product) {
      const products = this.people[personIndex].products;
      let show = true;
      let ids = [this.helmet_id];

      this.people[personIndex].products.forEach((userProduct) => {
        if (userProduct.includes_helmet) {
          if (ids.indexOf(product.pool_lid) !== -1) {
            show = false;
          }
        }
        if (userProduct.pool_lid === product.pool_lid) {
          show = false;
        }
      });

      return show;
    },
    addAddon(personIndex, product, keep) {
      let newProduct = Object.assign({}, product);
      if (!this.productIsAdded(personIndex, product)) {
        const days = this.people[personIndex].days;
        let prefix = (this.people[personIndex].priceType === 'night' ? '_night' : '');
        newProduct.price = newProduct.prices[`${days}${prefix}`].normal;
        newProduct.price_insurance = newProduct.prices[`${days}${prefix}`].with_insurance;
        this.addRentalAddon({
          index: personIndex,
          product: newProduct,
        });
      } else if (!keep) {
        this.removeRentalAddon({
          index: personIndex,
          product: newProduct,
        });
      }

      const addons = this.people[personIndex].addons.filter((p) => {
        return p.categories.filter((c) => {
          return c.slug === 'skipass';
        }).length ? false : true;
      });
      const products = this.people[personIndex].products.filter((p) => {
        return p.categories.filter((c) => {
          return c.slug === 'skipass';
        }).length ? false : true;
      });

      const sum = addons.length + products.length;

      this.$store.state.cart.rentals[personIndex].onlySkipass = !sum;
    },
    removeWish(personIndex, wishIndex) {
      let confirm = false;

      if (wishIndex === 'freeText') {
        this.openModal(['GeneralModal', {
          title: 'Är du säker?',
          content: `Vill du ta bort följande önskemål? <br><br> "${this.people[personIndex].wishes[wishIndex]}"`,
          yes: () => {
            this.people[personIndex].wishes[wishIndex] = '';
            this.closeModal();
          },
          no: () => {
            this.closeModal();
          }
        }]);
      } else {
        this.people[personIndex].wishes[wishIndex] = false;
      }
    },
    pickWishes(payload) {
      /* eslint-disable */
      for (let i in payload) {
        this.people[this.currentIndex].wishes[i] = payload[i];
      }
    },
    openWishes() {
      this.openModal(['SkiRentalWishes', {
        click: this.pickWishes,
        person: this.people[this.currentIndex],
        wishes: this.people[this.currentIndex].wishes,
      }]);
    },
    remove(index) {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('skirental.remove-confirmation', { skier: this.people[index].name }),
        buttons: [
          {
            title: this.$i18n.t('general.yes'),
            class: 'small',
            click: () => {
              $this.currentIndex = 0;
              $this.$store.state.cart.rentals.splice(index, 1);
              $this.reMount();
              $this.closeModal();
            },
          },
          {
            title: this.$i18n.t('general.no'),
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);

    },
    selectDates(start, end, type) {
      if (start) {
        this.$store.state.cart.rentals[this.currentIndex].startDate = start;
        let newEnd = end;
        if (!newEnd) {
          newEnd = start;
        }

        this.$store.state.cart.rentals[this.currentIndex].priceType = type;
        this.$store.state.cart.rentals[this.currentIndex].days = moment(newEnd).diff(start, 'days') + 1;

        this.updatePrices();
      }

      this.people[this.currentIndex].editing = false;
    },
    updatePrices() {
      let person = this.$store.state.cart.rentals[this.currentIndex];
      let newProducts = [];
      let newAddons = [];
      let prefix = (person.priceType === 'night' ? '_night' : '');
      person.products.forEach((product) => {
        let newProduct = Object.assign({}, product);
        newProduct.price = parseInt(product[`price_${person.days}${prefix}`], 10);
        newProducts.push(newProduct);
      });
      person.addons.forEach((addon) => {
        let newAddon = Object.assign({}, addon);
        newAddon.price = parseInt(addon[`price_${person.days}${prefix}`], 10);
        newAddons.push(newAddon);
      });
      person.products = newProducts;
      person.addons = newAddons;
    },
    changeDate() {
      let person = this.$store.state.cart.rentals[this.currentIndex];
      this.people[this.currentIndex].editing = true;
      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        pickedStartDate: person.startDate,
        pickedEndDate: ((person.days > 1) ? moment(person.startDate).add((person.days) - 1, 'days') : null),
        onClose: this.selectDates,
        onPickStart: this.setEndDates,
        night: this.SITE_CONFIG.season.winter.night,
      }]);
    },
    setEndDates() {
      const promise = new Promise((resolve) => {
        resolve(this.SITE_CONFIG.rental.days_max);
      });
      return promise;
    },
    dateRange(person) {
      let start = moment(person.startDate).toDate();
      let end = moment(person.startDate).add((person.days - 1), 'days').toDate();
      return [start, end];
    },
    setActive(item) {
      this.currentIndex = item;
    },
    next() {
      this.touchAll();
      if (!this.validate()) {
        return false;
      }
      this.completeGuides();
      this.$router.push({ path: `/skidhyra/${this.nextIndex}` });
    },
    addUsersToCart(config) {
      this.confirmRental(config);
      if (config.onlySave) {
        return;
      }
      if (config.noRedirect) {
        this.createOrderAndRedirect();
        return;
      }
      if (this.$store.state.isOnSite) {
        return;
      }

      const products = [];
      this.$store.state.cart.rentals.forEach((rental) => {
        rental.products.forEach((addon) => {
          products.push(addon);
        });
        rental.addons.forEach((addon) => {
          products.push(addon);
        });
      });

      window.trackAddToCart({
        title: 'Skidhyra',
        lines: products.map((product) => ({
          id: product.pool_lid,
          title: product.code,
          category: 'equipment',
          quantity: 1,
          price: product.price,
        })),
      });

      this.closeModal();

      if (config.payDirect) {
        this.$router.push({ path: `/varukorg?pay=1` });
      } else {
        this.$router.push({ path: `/varukorg?show-confirmation=1&ref=skirental` });
      }
      return;
    },
    async createOrderAndRedirect() {
      this.openModal(['CreatingOrder']);
    },
    touchAll() {
      const $this = this;
      this.people.forEach((person, index) => {
        $this.$set($this.touched, index, {});
        $this.$set($this.touched[index], 'lengthCm', true);
        $this.$set($this.touched[index], 'weight', true);
        $this.$set($this.touched[index], 'shoeSize', true);
        $this.$set($this.touched[index], 'pantsize', true);
        $this.$set($this.touched[index], 'jacketsize', true);
        $this.$set($this.touched[index], 'clothsize', true);
      });
    },
    doRental() {
      this.touchAll();
      if (!this.validate()) {
        return false;
      }
      this.openModal(['SkiRentalConfirm', {
        done: this.addUsersToCart,
      }]);
    },
    addons() {
      return this.allAddons;
    },
    validate() {
      let validated = true;
      const $this = this;
      this.people.forEach((person, index) => {
        if (person.guideCompleted) {
          let invalid = this.showError(index, 'lengthCm') || this.showError(index, 'weight') || this.showError(index, 'shoeSize') || this.showError(index, 'pantsize') || this.showError(index, 'jacketsize') || this.showError(index, 'clothsize');
          if (invalid) {
            validated = false;
          }
          if (!person.addons.length && !person.products.length) {
            validated = false;
          }
        }
      });
      return validated;
    },
    goBack() {
      let person = this.people[this.currentIndex];
      if (typeof person === 'undefined') {
        const people = this.people.filter(person => person.guideCompleted);
        person = people[people.length - 1];
        this.currentIndex = people.length - 1;
      }
      this.$router.push(`/skidhyra/${this.currentIndex}/produkter?age=${person.age}&category=${person.category}&type=${person.type}&level=${person.searchPackage}`);
    },
    infoPopup(item) {
      this.openModal(['GeneralModal', {
        title: item.name,
        content: item.description,
      }]);
    },
    hasClosedDaysInRange(person) {
      return hasClosedDaysInRange(person.startDate, person.days);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.component
  transition-slide('animate-filter')
  position: relative;
  +max-tablet()
    padding-top: 0


.underlined
  padding: 15px 20px 11px

  &.wishes-bt
    width: auto
    +max-tablet()
      width: 100%



.person
  background-color #ecf5f8
  margin-bottom 0px

  .inner-width
    max-width 1100px
    margin 0 auto
    padding 20px 0 10px
    position: relative;
  .addons
    &.inner-width
      padding-top: 0px
      position: relative;
      top: -20px
      min-height 100px
    .only-skipass-info
      padding-left: 15px;
    +max-tablet()
      padding-top: 0px
      max-height: none;


    .flex
      padding-bottom: 1rem

.blue-bar
  width 100%
  border-radius 0px
  background-color #005580
  padding: 10px 110px 14px;
  color white
  text-transform uppercase
  font-size 11px
  cursor pointer
  position relative
  height 38px
  +max-tablet()
    height auto
    padding: 10px 110px 14px 10px;
  .white
    position: relative;
    top: -3px;
    +max-tablet()
      top: 0px
  .inner
    max-width 1100px
    margin 0 auto
    .name
      united-heavy()
      font-size 17px
      color #ffffff
      text-transform none
      position relative
      top 2px
  .name,
  .package,
  .level,
  .right,
  .date,
  .change
    display inline-block
    margin-right 20px
    +max-mobile()
      display inline-block
      position: relative;
      margin-right: 5px
  .change
    +max-tablet()
      display: inline-block;
      margin-top: 0
      margin-bottom: 0px


  .change,
    top 3px
    position relative
    +max-tablet()
      top 6px
    +max-mobile()
      top 6px

  .delete
    +max-tablet()
      display: inline-block;

  .right
    float right

.person.completed
  .blue-bar
    background-color green-desaturated
    margin-bottom: 10px
    border-radius: 0px

h1
  text-transform none
  font-size 26px

.flex
  display flex
  padding-bottom space-3
  &.sizes-list
    padding-left: 15px;
  +max-tablet()
    flex-wrap: wrap
    padding-left 15px
    padding-right 15px
  //justify-content center
  .control
    margin-left 0
    margin-right 18px
    width 255px
    +max-tablet()
      width: 29%
      margin-right: 2%;
      margin-left: 2%;
      flex: 1 1 46%;
    +max-xs-mobile()
      width: 100%;
      max-width 100%
      min-width 0
      margin-right: 0;
      margin-left: 0;
      flex: 1 1 100%;
    .label
      font-size 13px
      font-weight bold
      color black
      margin-bottom: 10px
      +max-tablet()
        margin-top 10px
        margin-bottom: 15px
      button
        float none
        margin-left: 6px;
    .input
      input()
      min-width 100%
      max-width 100%
      &.error
        border-color warning

.show-or-close
  position absolute
  right 0
  top 0
  height 38px
  +max-tablet()
    height: 100%
  .text
    height 38px
    font-size 11px
    font-weight bold
    padding-right: 12px
    line-height: 38px
    display inline-block
    margin-top -1px
  .arrow
    width 48px
    height 38px
    line-height: 38px
    display inline-block
    margin-top -1px
    background-color rgba(255, 255, 255, 0.8)
    text-align: center;
    +max-tablet()
      height: 100%
.opened
  .package,
  .level,
  .date
    display: relative
    +max-mobile()
      display: none
  .show-or-close
    .arrow
      background-color rgba(255, 255, 255, 0.1)

.addon--inner-width
  background-color #f0f7f9
  box-shadow inset 0 0 12px 0 rgba(0, 0, 0, 0.08)

h4
  uppercase()
  united-heavy()
  font-size: 16px
  margin-left: 5px
  padding-left padding-mobile
  padding-right padding-mobile

.addon-list
  display flex
  flex-wrap wrap
  padding 5px
  padding-left: 15px;
  +max-tablet()
    padding-left padding-mobile
    padding-right padding-mobile
  & > *
    width 255px
    border-radius 2px
    background-color #ffffff
    box-shadow 0 0 10px 0 rgba(0, 0, 0, 0.1)
    margin-right 18px
    margin-bottom 18px
    display flex
    border solid 2px white
    +max-tablet()
      width: 29%
      margin-right: 2%;
      margin-left: 2%;
      margin-bottom: 20px
    +max-mobile()
      width 46%
    +max-xs-mobile()
      width: 96%;

    &.active
      border-color #c7dcb7
      box-shadow 0 0 0px 0 rgba(0, 0, 0, 0)
    .image
      width 76.6px
      height 82px
      border-radius 2px
      background-color rgba(225, 239, 243, 0.3)
      background-size 100%
      background-repeat no-repeat
      background-position center
      margin-right: 8px
      .icon
        display: none
      &.has-description
        position: relative
        cursor pointer
        .icon
          position absolute
          display: block;
          bottom 5px
          left 5px
    .content
      width calc(100% - 85px)
      padding-right 6px
      padding-bottom 6px
      h4
        font-family Interstate
        font-size 13px
        font-weight bold
        color #262626
        uppercase()
        margin-left: 0px
        margin-bottom: 4px
        letter-spacing: 0px
        padding-left 0
      p
        font-size 11px
        margin-bottom 0
      .float-right
        float right

.space-3
  margin space-3

.products
  background-color white
  border-radius: 3px
  position: relative;
  position: absolute;
  right: 20px;
  bottom: 15px;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
  max-width 240px
  table
    width: 100%
  +max-mobile()
    width: 100%
  .heading-products
    background-color: deep-blue
    padding: 8px 10px 6px 12px
    border-top-left-radius: 4px
    border-top-right-radius: 4px
    color: #fff
    text-transform: uppercase
    letter-spacing: 0.02em
    font-weight: bold
    font-size: 13px
  +max-tablet()
    position: relative;
    right: auto;
    width: 60%;
    margin: 0 auto
    margin-top: 20px
    max-width: 400px
    min-width: 340px;
  +max-mobile()
    bottom: 15px;
    margin-top: 20px
    min-width: 0;
    width 100%
    max-width 100%



  tr
    td
      padding 6px 10px
      font-size 13px
      font-weight 300
      color #262626
      border-bottom solid 1px rgba(191, 217, 225, 0.5)
      vertical-align: top
      word-break: break-word;
      &.price
        text-align right
        white-space: nowrap;
        word-break: normal;
    &.total
      td
        font-size 12px
        font-weight: 600
        color greyish-brown
        &.price
          font-size 16px
          color #262626

.filter-list-item
  display inline-flex
  margin-right 3px
  margin-bottom 3px

.sum-bar
  font-weight bold
  letter-spacing -0.2px
  color #262626
  font-weight: normal;
  font-size: 12px;
  .inner
    max-width 1100px
    margin 0 auto
    padding-top 15px
    padding-bottom 15px
    padding-right 20px
    b
      font-size 16px
      font-weight bold
      color #262626

.button-confirm
  position: relative;
  top -60px
  +max-tablet()
    top auto
    position:relative;
    margin-top 0
    top 10px


button
  &.white
    &.border
      &.big
        padding: 13px 20px;
        position: relative;
        top: -3px;
        top: -3px;
        font-size: 11px;

.language-switcher
  position absolute
  right 10px
  top 5px
  width: auto
  display inline-block
  padding: 5px 10px;

+max-tablet()
  hr
    display none
  .language-switcher
    top 3px
  .go-back
    display inline-block
    background-color: pale-grey
    padding: 14px 15px 12px;
    color deep-sea-blue
    position absolute
    top 0
    left 0
    font-weight bold
    width: 100%
    font-size: 12px;
    z-index: 9999999
    top: 65px
    uppercase()
    .icon
      position: relative
      top: -1px
      margin-right: 7px
.button-confirm
  button
    font-size: 12px
    padding: 8px 10px 4px 10px
    display: inline-block;
    margin-left: 20px
    +max-tablet()
      margin-left: 0px
    &.small
      &.white
        font-size: 10px
        padding: 9px 10px 6px 10px
        display: inline-block
        position: relative
        top: 1px
        margin-right: 10px
  span
    display: none

.error-message
  padding-left 20px
  margin-bottom 20px
  display block

.rental-closed
  text-align center
  margin 4em auto
  max-width 650px
  font-size 16px
  line-height 1.5
  padding 0 20px
</style>



// WEBPACK FOOTER //
// SkiRentalUserOverview.vue?bb8c18da